export const portfolioItems = [
  { 
    id: 1, 
    title: "Nike Brand Campaign", 
    category: "Branding", 
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=80",
    client: "Nike Inc."
  },
  { 
    id: 2, 
    title: "Architectural Digest", 
    category: "Photography", 
    image: "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?auto=format&fit=crop&q=80",
    client: "AD Magazine"
  },
  { 
    id: 3, 
    title: "TechFlow App UI", 
    category: "Design", 
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&q=80",
    client: "TechFlow"
  },
  { 
    id: 4, 
    title: "Eco Friendly Packaging", 
    category: "Branding", 
    image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&q=80",
    client: "Leaf & Co"
  },
  { 
    id: 5, 
    title: "Urban Portrait Series", 
    category: "Photography", 
    image: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&q=80",
    client: "Personal"
  },
  { 
    id: 6, 
    title: "Neon Cyberpunk 3D", 
    category: "3D Art", 
    image: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&q=80",
    client: "CryptoGame"
  }
];

export const services = [
    { title: "UI/UX Design", desc: "User-centered digital experiences." },
    { title: "Brand Identity", desc: "Crafting memorable visual stories." },
    { title: "Photography", desc: "Capturing moments that matter." },
];
